import { InjectionToken } from '@angular/core';

export const REPORTING_BASE: InjectionToken<string> = new InjectionToken(
  'REPORTING_BASE'
);
